import React from 'react';
import './Footer.css';

/**
 * @Component The footer of application
 * @description Contains attributions to icons used
 */
const Footer = () => {
  return (
    <footer>
      Made for fun by&nbsp;
      <a href="https://github.com/ananthakrishna-hs">
        Ananth
      </a>.<br/>
      Icons Attributions:
      <div>
        Icons made by&nbsp;
        <a href="https://www.flaticon.com/authors/freepik" title="Freepik">
          Freepik
        </a> from&nbsp;
        <a href="https://www.flaticon.com/" title="Flaticon">
          www.flaticon.com
        </a>
      </div>
      <div>
        Icons made by&nbsp;
        <a href="https://www.flaticon.com/authors/smashicons" title="Smashicons">
          Smashicons
        </a> from&nbsp;
        <a href="https://www.flaticon.com/" title="Flaticon">
          www.flaticon.com
        </a>
      </div>
      <div>Icons made by&nbsp;
        <a href="https://www.flaticon.com/authors/kiranshastry" title="Kiranshastry">
          Kiranshastry
        </a> from&nbsp;
        <a href="https://www.flaticon.com/" title="Flaticon">
          www.flaticon.com
        </a>
      </div>
    </footer>
  );
}

export default Footer;